<template>
  <NetworkStatusBanner />
  <router-view />
</template>

<script>
import NetworkStatusBanner from './components/NetworkStatusBanner.vue'

export default {
  name: 'App',
  components: { NetworkStatusBanner }
}
</script>

<style>
#app {
  /* font-family: Ubuntu, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
     Cantarell, sans-serif; */
     font-family: Roboto, arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
</style>
